import React, { FC } from 'react';

import { API_REPORT_TABLE } from '../../../shared/common/api/urls';
import MainLayout from '../../../shared/common/components/layouts/MainLayout';
import PageHead from '../../../shared/common/components/page-header/PageHeader';
import TableReport from '../../../shared/common/components/reports/table-report/TableReport';

const WebinarAttendance: FC = () => {

    const metrics = [
        { name: 'ID пользователя', dataKey: 'id' },
        { name: 'Имя', dataKey: 'name' },
        { name: 'Email', dataKey: 'email' },
        { name: 'ID вебинара', dataKey: 'webinar_id' },
        { name: 'Название вебинара', dataKey: 'webinar_name' },
        { name: 'Действие', dataKey: 'webinar_action_type' },
        { name: 'Дата', dataKey: 'webinar_date' },
        { name: 'Время', dataKey: 'webinar_time' },
    ];

    const defaultSort: Record<string, 'ASC' | 'DESC'> = {
        webinar_date: 'DESC',
        webinar_time: 'DESC',
        id: 'ASC',
    };

    return (
        <MainLayout pageTitle="Посещение вебинара">
            <div className="page-wrapper">
                <PageHead
                    title="Посещение вебинара"
                />

                <div className="page-content">
                    <TableReport
                        apiUrl={API_REPORT_TABLE}
                        metrics={metrics}
                        filtersFilter={[ 'Пользователи', 'Вебинары' ]}
                        defaultSort={defaultSort}
                    />
                </div>
            </div>
        </MainLayout>
    );
};

export default WebinarAttendance;
